import i18n from 'src/i18n.js';
const t = (key) => i18n.t(key);
// Executed when additional procedure radio buttons are selected/unselected
export const getModifiedPhysicianFinderData = (
    procedureInfoData,
    selectedVal,
    modifiedAdditionalProcedureData,
    selectedAdditionalProcedureIdx
) => {
    let modifiedPhysicianFinderData;
    if (
        modifiedAdditionalProcedureData[selectedAdditionalProcedureIdx]
            .description === 'Stealth S7/S8 Navigation' ||
        modifiedAdditionalProcedureData[selectedAdditionalProcedureIdx]
            .description === 'MazorX Robot Used'
    ) {
        const selectedIdx = procedureInfoData.therapies.findIndex((phy) =>
            phy.description.includes(
                modifiedAdditionalProcedureData[selectedAdditionalProcedureIdx]
                    .description === 'Stealth S7/S8 Navigation'
                    ? 'Navigation'
                    : 'Robotics'
            )
        );
        if (selectedIdx >= 0) {
            modifiedPhysicianFinderData = [...procedureInfoData.therapies];
            modifiedPhysicianFinderData[selectedIdx].isSelected = selectedVal;
            const noneIdx = modifiedPhysicianFinderData.findIndex(
                (phy) => phy.description === 'None'
            );
            if (
                selectedVal &&
                noneIdx >= 0 &&
                modifiedPhysicianFinderData[noneIdx].isSelected
            ) {
                modifiedPhysicianFinderData[noneIdx].isSelected = false;
            }
        }
    }
    return modifiedPhysicianFinderData;
};

// Executed when deformity correction radio buttons are selected/unselected

export const getModifiedDeformityCorrectionData = (
    procedureInfoData,
    selectedIdx,
    selectedVal
) => {
    const modifiedData = [...procedureInfoData.technologies];

    // Loop through all items and set isSelected based on index
    modifiedData.forEach((item, index) => {
        item.isSelected = index === selectedIdx ? selectedVal : null;
    });

    return modifiedData;
};

// Executed when physician finder checkboxes are selected/unselected
export const getModifiedAdditionalProcedureData = (
    procedureInfoData,
    selectedCheckboxVal,
    isChecked
) => {
    let modifiedAdditionalProcedureData;
    if (
        selectedCheckboxVal === 'None' ||
        selectedCheckboxVal.includes('Navigation') ||
        selectedCheckboxVal.includes('Robotics')
    ) {
        modifiedAdditionalProcedureData = [
            ...procedureInfoData.additionalProcedure,
        ];
        if (selectedCheckboxVal === 'None' && isChecked) {
            const roboticsIdx = modifiedAdditionalProcedureData.findIndex(
                (addProc) => addProc.description.includes('Robot')
            );
            if (
                roboticsIdx >= 0 &&
                modifiedAdditionalProcedureData[roboticsIdx].isSelected
            ) {
                modifiedAdditionalProcedureData[roboticsIdx].isSelected = false;
            }
            const navigationIdx = modifiedAdditionalProcedureData.findIndex(
                (addProc) =>
                    addProc.description.includes('Stealth S7/S8 Navigation')
            );
            if (
                navigationIdx >= 0 &&
                modifiedAdditionalProcedureData[navigationIdx].isSelected
            ) {
                modifiedAdditionalProcedureData[
                    navigationIdx
                ].isSelected = false;
            }
        } else if (
            selectedCheckboxVal.includes('Navigation') ||
            selectedCheckboxVal.includes('Robotics')
        ) {
            const selectedIdx = modifiedAdditionalProcedureData.findIndex(
                (addProc) =>
                    addProc.description.includes(
                        selectedCheckboxVal.includes('Navigation')
                            ? 'Stealth S7/S8 Navigation'
                            : 'Robot'
                    )
            );
            modifiedAdditionalProcedureData[selectedIdx].isSelected = isChecked;
        }
    }
    return modifiedAdditionalProcedureData;
};

// Executed when physician finder checkboxes are selected/unselected
export const getModifiedPhysicianFinderDataOnCheckboxSelection = (
    procedureInfoData,
    selectedCheckboxIdx,
    selectedCheckboxVal,
    isChecked
) => {
    let modifiedData = [...procedureInfoData.therapies];
    modifiedData[selectedCheckboxIdx].isSelected = isChecked;

    if (selectedCheckboxVal === 'None' && isChecked) {
        modifiedData = modifiedData.map((x) =>
            x.description === 'None'
                ? x
                : { ...x, isSelected: x.isSelected ? false : x.isSelected }
        );
    } else {
        const noneIdx = modifiedData.findIndex(
            (phy) => phy.description === 'None'
        );
        if (noneIdx >= 0 && modifiedData[noneIdx].isSelected) {
            modifiedData[noneIdx].isSelected = false;
        }
    }
    return modifiedData;
};

// Executed when retractor used radio buttons are selected/unselected
export const getModifiedRetractorUsedOnCheckboxSelection = (
    procedureInfoData,
    selectedCheckboxIdx,
    selectedCheckboxVal,
    isChecked
) => {
    let modifiedData = [...procedureInfoData.retractors];
    modifiedData[selectedCheckboxIdx].isSelected = isChecked;

    if (selectedCheckboxVal === 'None' && isChecked) {
        modifiedData = modifiedData.map((x) =>
            x.description === 'None'
                ? x
                : { ...x, isSelected: x.isSelected ? false : x.isSelected }
        );
    } else {
        const noneIdx = modifiedData.findIndex(
            (phy) => phy.description === 'None'
        );
        // const otherIdx = modifiedData.findIndex(
        //     (phy) => phy.description === 'Other'
        // );
        // console.log('otherIdx', otherIdx);
        if (noneIdx >= 0 && modifiedData[noneIdx].isSelected) {
            modifiedData[noneIdx].isSelected = false;
        }
        // else if (otherIdx >= 0 && modifiedData[otherIdx].isSelected) {
        //     modifiedData[otherIdx].isSelected = false;
        // }
    }
    return modifiedData;
};

// export const getModifiedUivLevelsSelection = (
//     levelsData,
//     uivDropdownCode,
//     livDropdownCode,
//     selectedVal,
//     isUivSelected,
//     isLivSelected
// ) => {
//     let modifiedData = [...levelsData];
//     let uivIdx = modifiedData.findIndex((phy) => phy.code === uivDropdownCode);
//     console.log('uivIdx', uivIdx);
//     console.log('isUivSelectedInDTS', isUivSelected);
//     console.log('isLivSelectedInDTS', isLivSelected);
//     if (uivIdx >= 0) {
//         modifiedData[uivIdx].isSelected = isUivSelected;
//         modifiedData = modifiedData.map((x) =>
//         (x.isSelected === isUivSelected && x.code === uivDropdownCode) || (x.isSelected === isLivSelected && x.code === livDropdownCode)
//                 ? x
//                 : { ...x, isSelected: x.isSelected===true ? null : x.isSelected }
//         );
//     } else if (uivIdx < 0) {
//         modifiedData = modifiedData.map((x) =>
//             (x.code === livDropdownCode) || (x.code === uivDropdownCode)
//                 ? { ...x, isSelected: false }
//                 : { ...x, isSelected: x.isSelected===true ? null : x.isSelected }
//         );
//     }
//     console.log('modifiedDataUivFirstLevel', modifiedData);
//     return modifiedData;
// };

// export const getModifiedLivLevelsSelection = (
//     levelsData,
//     livDropdownCode,
//     uivDropdownCode,
//     selectedVal,
//     isLivSelected,
//     isUivSelected
// ) => {
//     let modifiedData = [...levelsData];
//     let livIdx = modifiedData.findIndex((phy) => phy.code === livDropdownCode);
//     console.log('livIdx', livIdx);
//     console.log('isLivSelectedInDTS', isLivSelected);
//     console.log('isUivSelectedInDTS', isUivSelected);
//     if (livIdx >= 0) {
//         modifiedData[livIdx].isSelected = isLivSelected;
//         modifiedData = modifiedData.map((x) =>
//             (x.isSelected === isLivSelected && x.code === livDropdownCode) || (x.isSelected === isUivSelected && x.code === uivDropdownCode)
//                 ? x
//                 : { ...x, isSelected: x.isSelected===true ? null : x.isSelected }
//         );
//     } else if(livIdx < 0) {

//         modifiedData = modifiedData.map((x) =>
//             (x.code === livDropdownCode) || (x.code === uivDropdownCode)
//                 ? { ...x, isSelected: false }
//                 : { ...x, isSelected: x.isSelected===true ? null : x.isSelected }
//         );
//     }
//     console.log('modifiedDataLivFirstLevel', modifiedData);
//     return modifiedData;
// };

export const getModifiedFirstLevelsSelection = (
    levelsData,
    uivDropdownCode,
    livDropdownCode,
    selectedVal,
    isUivSelected,
    isLivSelected
) => {
    let modifiedData = [...levelsData];
    let uivIdx = modifiedData.findIndex((phy) => phy.code === uivDropdownCode);
    if (uivIdx >= 0) {
        modifiedData[uivIdx].isSelected = isUivSelected;
        modifiedData = modifiedData.map((x) =>
            (x.isSelected === isUivSelected && x.code === uivDropdownCode) ||
            (x.isSelected === isLivSelected && x.code === livDropdownCode)
                ? x
                : {
                      ...x,
                      isSelected: x.isSelected === true ? false : x.isSelected,
                  }
        );
    } else {
        modifiedData = modifiedData.map((x) => ({
            ...x,
            isSelected: x.isSelected === true ? false : x.isSelected,
        }));
    }
    return modifiedData;
};

export const getModifiedLevelsSelection = (
    levelsData,
    livStateCode,
    uivStateCode
) => {
    let modifiedData = [...levelsData];
    let uivIdx = modifiedData.findIndex((phy) => phy.code === uivStateCode);
    let livIdx = modifiedData.findIndex((phy) => phy.code === livStateCode);
    if (uivIdx >= 0 && livIdx >= 0) {
        modifiedData = modifiedData.map((x) =>
            x.code === uivStateCode || x.code === livStateCode
                ? { ...x, isSelected: true }
                : {
                      ...x,
                      isSelected: x.isSelected === true ? null : x.isSelected,
                  }
        );
    } else if ((uivIdx < 0 && livIdx >= 0) || (uivIdx >= 0 && livIdx < 0)) {
        modifiedData = modifiedData.map((x) =>
            x.code === uivStateCode || x.code === livStateCode
                ? { ...x, isSelected: null }
                : {
                      ...x,
                      isSelected: x.isSelected === true ? null : x.isSelected,
                  }
        );
    }
    return modifiedData;
};

// export const getModifiedLevelsSelectionAfterDelete = (
//     levelsData,
//     deletedUivCode,
//     deletedLivCode
// ) => {
//     let modifiedData = [...levelsData];
//     let uivIdx = modifiedData.findIndex((phy) => phy.code === deletedUivCode);
//     let livIdx = modifiedData.findIndex((phy) => phy.code === deletedLivCode);
//     console.log('DeletedUivIdx', uivIdx);
//     console.log('DeletedLivIdx', livIdx);
//     console.log('deletedUivCode', deletedUivCode);
//     console.log('deletedLivCode', deletedLivCode);
//     console.log('modifiedData', modifiedData);
//         // modifiedData[uivIdx].isSelected = isUivSelected;
//     if(uivIdx >= 0 && livIdx >= 0){
//         modifiedData = modifiedData.map((x) =>
//             (x.code === deletedUivCode) || (x.code === deletedLivCode)
//                 ? { ...x, isSelected: x.isSelected===false || x.isSelected===true ? null : x.isSelected }
//                 : { ...x }
//         );
//     }
//     return modifiedData;
// };

// export const getModifiedLevelsSelection = (levelsData, uivStateCode, livStateCode, procedureLevels) => {
//     // Create a set of IDs from procedureLevels for quick lookup

//     let modifiedData = [...levelsData];
//     const errorLevelCode = new Set();
//     const procedureLevelCode = new Set();

//     procedureLevels?.forEach(level => {
//         if (level.uivDropdown.uivState.code && !level.error) {
//             procedureLevelCode.add(level.uivDropdown.uivState.code);
//         }
//         if (level.livDropdown.livState.code && !level.error) {
//             procedureLevelCode.add(level.livDropdown.livState.code);
//         }
//         if(level.error){
//             errorLevelCode.add(level.uivDropdown.uivState.code);
//             errorLevelCode.add(level.livDropdown.livState.code);
//         }
//     });

//     console.log('modifiedDataNewData', modifiedData);
//     console.log('errorLevelCode', errorLevelCode);
//     console.log('procedureLevelCode', procedureLevelCode);
//     // Map through levelsData to update the isSelected property
//     // const modifiedData = levelsData.map(level => {
//     //     if (errorLevelCode.has(level.code)) {
//     //         return {
//     //             ...level,
//     //             isSelected: false
//     //         };
//     //     } else if (procedureLevelCode.has(level.code) && level.isSelected !== false) {
//     //         return {
//     //             ...level,
//     //             isSelected: true
//     //         };
//     //     }
//     //     return level; // Return the level unchanged if it doesn't match
//     // });

//     modifiedData = modifiedData.map((level) =>{
//         if((level.code===uivStateCode || level.code===livStateCode) && (errorLevelCode.has(uivStateCode) || errorLevelCode.has(livStateCode))){
//             return {
//                 ...level,
//                 isSelected: false // Set isSelected to null for the levels present in procedureLevels
//             };
//         }
//         else if(procedureLevelCode.has(uivStateCode) || procedureLevelCode.has(livStateCode)){
//             return {
//                 ...level,
//                 isSelected: true // Set isSelected to null for the levels present in procedureLevels
//             };
//         }
//         else if(errorLevelCode.has(level.code)){
//             return {
//                 ...level,
//                 isSelected: false // Set isSelected to null for the levels present in procedureLevels
//             };
//         }
//         else{
//             return {
//                 ...level,
//             };
//         } // Return the level unchanged if it doesn't match
//     });
//     console.log('modifiedDataNewData', modifiedData);
//     return modifiedData;
// };

export const getModifiedErrorLevelsSelection = (
    levelsData,
    errorMsg,
    uivCode,
    livCode,
    procedureLevels
) => {
    let modifiedData = [...levelsData];
    // console.log('modifiedData', modifiedData);

    // const errorLevelCode = new Set();
    // const procedureLevelCode = new Set();

    // procedureLevels?.forEach(level => {
    //     if (level.uivDropdown.uivState.code && !level.error) {
    //         procedureLevelCode.add(level.uivDropdown.uivState.code);
    //     }
    //     if (level.livDropdown.livState.code && !level.error) {
    //         procedureLevelCode.add(level.livDropdown.livState.code);
    //     }
    //     if(level.error){
    //         errorLevelCode.add(level.uivDropdown.uivState.code);
    //         errorLevelCode.add(level.livDropdown.livState.code);
    //     }
    // });
    // procedureLevels?.forEach(level => {
    //     if(level.error){
    //         errorLevelCode.add(level.uivDropdown.uivState.code);
    //         errorLevelCode.add(level.livDropdown.livState.code);
    //     }
    // });

    // if(errorMsg){
    //     console.log('errorMsg', errorMsg);
    modifiedData = modifiedData.map((level) => {
        // if(errorMsg && (level.code === uivCode || level.code === livCode)){
        //     return {
        //         ...level,
        //         isSelected: false // Set isSelected to null if the level.code matches deletedUiv or deletedLiv
        //     };
        // }
        // else
        if (errorMsg) {
            return {
                ...level,
                isSelected: false, // Set isSelected to null for the levels present in procedureLevels
            };
        } else {
            return {
                ...level,
            };
        } // Return the level unchanged if it doesn't match
    });
    // }
    return modifiedData;
};

// export const getModifiedLevelsSelectionAfterDelete = (levelsData, errorMsg, deletedUivCode, deletedLivCode, procedureLevels) => {

//     console.log('deletedUivCode', deletedUivCode);
//     console.log('deletedLivCode', deletedLivCode);

//     const procedureLevelCode = new Set();
//     const errorLevelCode = new Set();

//     procedureLevels?.forEach(level => {
//         if (level.uivDropdown.uivState.code && !level.error) {
//             procedureLevelCode.add(level.uivDropdown.uivState.code);
//         }
//         if (level.livDropdown.livState.code && !level.error) {
//             procedureLevelCode.add(level.livDropdown.livState.code);
//         }
//         if(level.error){
//             errorLevelCode.add(level.uivDropdown.uivState.code);
//             errorLevelCode.add(level.livDropdown.livState.code);
//         }
//     });
//     procedureLevels?.forEach(level => {
//         if(level.error){
//             errorLevelCode.add(level.uivDropdown.uivState.code);
//             errorLevelCode.add(level.livDropdown.livState.code);
//         }
//     });

//     let modifiedData = [...levelsData];
//     console.log('modifiedData', modifiedData);
//     console.log('procedureLevelCode', procedureLevelCode);
//     console.log('errorLevelCode', errorLevelCode);

//     modifiedData = levelsData.map(level => {
//         if (errorMsg && (level.code === deletedUivCode) || level.code === deletedLivCode) {
//             return {
//                 ...level,
//                 isSelected: null // Set isSelected to null if the level.code matches deletedUiv or deletedLiv
//             };
//         }
//         else if(procedureLevelCode.has(level.code) && !errorLevelCode.has(level.code)){
//             return {
//                 ...level,
//                 isSelected: true // Set isSelected to null for the levels present in procedureLevels
//             };
//         }
//         else if(errorLevelCode.has(level.code)){
//             return {
//                 ...level,
//                 isSelected: false // Set isSelected to null for the levels present in procedureLevels
//             };
//         }
//         //  if(!errorLevelCode.has(level.code)){
//         //     return {
//         //         ...level,
//         //         isSelected: null // Set isSelected to null for the levels present in procedureLevels
//         //     };
//         // }
//         else {
//             return {
//                 ...level,
//             };
//         }
//     });
//     console.log('modifiedDataAfterDelete', modifiedData);
//     return modifiedData;
// };

export const getModifiedBiologicsUsedDataOnCheckboxSelection = (
    procedureInfoData,
    selectedCheckboxIdx,
    selectedCheckboxVal,
    isChecked
) => {
    let modifiedData = [...procedureInfoData.biologicsUsed];
    modifiedData[selectedCheckboxIdx].isSelected = isChecked;

    if (selectedCheckboxVal === '01' && isChecked) {
        modifiedData = modifiedData.map((x) =>
            x.code === '01'
                ? x
                : { ...x, isSelected: x.isSelected ? false : x.isSelected }
        );
    } else {
        const noneIdx = modifiedData.findIndex((phy) => phy.code === '01');
        if (noneIdx >= 0 && modifiedData[noneIdx].isSelected) {
            modifiedData[noneIdx].isSelected = false;
        }
    }
    return modifiedData;
};

export const isUnidSurgeryFooterBtnEnabled = (unidSurgeryInfo) => {
    const fewProducts = unidSurgeryInfo.unidProducts.filter(
        (product) => product.productCFN !== 'None' && product.isChecked
    ).length;

    let isCheckedWhyAllRodsNotImplantedAsMainRod = () => {
        let selectedReason = unidSurgeryInfo.whyAllRodsNotImplanted.filter(
            (item) => item.isChecked
        );

        if (selectedReason && selectedReason.length > 0) {
            if (
                selectedReason.find((item) => item.id === 2) ||
                selectedReason.find((item) => item.id === 4)
            ) {
                return unidSurgeryInfo.mPXR;
            } else {
                return true;
            }
        }
    };

    //Executes when All rod items Selected except None.
    if (
        fewProducts > 0 &&
        fewProducts === unidSurgeryInfo.unidProducts.length - 1
    ) {
        let ImplantedItems = unidSurgeryInfo.unidProducts.filter(
            (product) => product.productCFN !== 'None' && product.isChecked
        );

        if (unidSurgeryInfo.mainRodCount == 2) {
            return true;
        } else if (
            (unidSurgeryInfo.mainRodCount > 0 &&
                unidSurgeryInfo.mainRodCount !== 2) ||
            unidSurgeryInfo.mainRodCount == 0
        ) {
            return (
                ImplantedItems.every(
                    (product) => product.implantedAsMainRod !== null
                ) &&
                (ImplantedItems.every((product) => {
                    if (product.implantedAsMainRod === 'No') {
                        // isCheckedWhyNotImplantedAsMainRod();
                        let selectedItems =
                            product.whyNotImplantedAsMainRod.filter(
                                (data) => data.isChecked
                            );

                        if (selectedItems && selectedItems.length > 0) {
                            if (
                                selectedItems.find((item) => item.id === 2) ||
                                selectedItems.find((item) => item.id === 4)
                            ) {
                                return unidSurgeryInfo.mPXR;
                            } else {
                                return true;
                            }
                        }
                    }
                }) ||
                    ImplantedItems.some((product) => {
                        return product.implantedAsMainRod == 'Yes';
                    }))
            );
        }
    } else if (
        unidSurgeryInfo.unidProducts.some((product) => product.isChecked)
    ) {
        //Executes for None Selected.
        if (
            unidSurgeryInfo.unidProducts.some(
                (product) => product.productCFN === 'None' && product.isChecked
            )
        ) {
            return isCheckedWhyAllRodsNotImplantedAsMainRod();
        } else if (
            fewProducts > 0 &&
            fewProducts < unidSurgeryInfo.unidProducts.length - 1
        ) {
            // Executes (t-1) Case, where t is Total number of rods selected.

            if (unidSurgeryInfo.mainRodCount == 2) {
                return isCheckedWhyAllRodsNotImplantedAsMainRod();
            } else if (
                (unidSurgeryInfo.mainRodCount > 0 &&
                    unidSurgeryInfo.mainRodCount !== 2) ||
                unidSurgeryInfo.mainRodCount == 0
            ) {
                let ImplantedItemsArray = unidSurgeryInfo.unidProducts.filter(
                    (product) =>
                        product.productCFN !== 'None' && product.isChecked
                );

                return (
                    isCheckedWhyAllRodsNotImplantedAsMainRod() &&
                    ImplantedItemsArray.every(
                        (product) => product.implantedAsMainRod !== null
                    ) &&
                    (ImplantedItemsArray.every((product) => {
                        if (product.implantedAsMainRod === 'No') {
                            // isCheckedWhyNotImplantedAsMainRod();
                            let selectedItems =
                                product.whyNotImplantedAsMainRod.filter(
                                    (data) => data.isChecked
                                );

                            if (selectedItems && selectedItems.length > 0) {
                                if (
                                    selectedItems.find(
                                        (item) => item.id === 2
                                    ) ||
                                    selectedItems.find((item) => item.id === 4)
                                ) {
                                    return unidSurgeryInfo.mPXR;
                                } else {
                                    return true;
                                }
                            }
                        }
                    }) ||
                        ImplantedItemsArray.some((product) => {
                            return product.implantedAsMainRod == 'Yes';
                        }))
                );
            }
        }
    }
};

export const getExistingUnidProducts = (
    existingUnidItems,
    itemTableData,
    unidImplanteditems
) => {
    const unidProducts = [];
    // let overAllUniqueId = 0;
    existingUnidItems &&
        existingUnidItems.forEach((unidItem) => {
            if (
                !unidProducts
                    .map((x) => x.productCFN)
                    .includes(unidItem.productCFN)
            ) {
                unidItem && unidItem?.totalDeliveredQty && [...Array(Number(unidItem?.totalDeliveredQty))]?.map(
                    (caseLevelData, index) => {
                        let whyNotImplantedAsMainRodQun = [
                            {
                                id: 1,
                                label: t(
                                    'procedure.unid.SurgeonChangedSurgicalPlan'
                                ),
                                isChecked: false,
                            },
                            {
                                id: 2,
                                label: t(
                                    'procedure.unid.IssuewithLengthorContour'
                                ),
                                isChecked: false,
                            },
                        ];

                        const itemCFN = unidItem.parentCFN
                            ? unidItem.parentCFN
                            : unidItem.productCFN;
                        const unidItemObj = {
                            productCFN: itemCFN,
                            salesOrg: unidItem.salesOrg,
                            isChecked: true,
                            uniqQty: 1,
                            unidCounter: index + 1,
                            unidLineNumber: unidItem.unidLineNumber,
                            whyNotImplantedAsMainRod:
                                whyNotImplantedAsMainRodQun,
                            implantedAsMainRod: null,
                            // overAllUniqueId: overAllUniqueId,
                            parentLineNumber: unidItem.parentLineNumber,
                        };
                        if (!unidItemObj.isChecked) {
                            let isChecked = false;
                            itemTableData.forEach((item) => {
                                if (
                                    !isChecked &&
                                    item.isBundleItem &&
                                    item.children &&
                                    item.children.length > 0
                                ) {
                                    isChecked = item.children
                                        .map((childItem) => childItem.cfn)
                                        .includes(itemCFN);
                                    unidItemObj.isChecked = isChecked;
                                }
                            });
                        }
                        if (unidItem.isUnidRodItem) {
                            unidItemObj.isUnidRodItem = unidItem.isUnidRodItem;
                        }
                        if (unidItem.description) {
                            unidItemObj.description = unidItem.description;
                        }
                        if (unidItem.uom) {
                            unidItemObj.uom = unidItem.uom;
                        }
                        if (unidItem?.rodEtching) {
                            unidItemObj.rodEtching = unidItem?.rodEtching;
                        }

                        unidProducts.push(unidItemObj);
                    }
                );
            }
            // overAllUniqueId++;
        });

    // draft case
    if (unidImplanteditems && unidImplanteditems.length > 0) {
        unidProducts.map((unid) => {
            unidImplanteditems.map((data) => {
                let getImplantedProducts = [];
                if (
                    data.unidRodCFN === unid.productCFN &&
                    data.unidLineNumber === unid.unidLineNumber &&
                    data.unidCounter === unid.unidCounter &&
                    data.parentUniqueLineNumber === unid.parentLineNumber
                ) {
                    getImplantedProducts = data;
                }

                if (Object.keys(getImplantedProducts).length > 0) {
                    unid.productCFN = getImplantedProducts.unidRodCFN;
                    unid.isChecked = getImplantedProducts.rodImplanted;

                    let modifeidwhyNotImplantedAsMainRod = [
                        ...unid.whyNotImplantedAsMainRod,
                    ];
                    modifeidwhyNotImplantedAsMainRod.map((data) => {
                        data.isChecked =
                            data.id == 1
                                ? getImplantedProducts.isRodSurgeonChangedSurgicalPlan
                                : data.id == 2
                                ? getImplantedProducts.isRodIssueWithLengthOrContour
                                : false;
                    });

                    unid.whyNotImplantedAsMainRod =
                        modifeidwhyNotImplantedAsMainRod;
                    unid.implantedAsMainRod =
                        typeof getImplantedProducts.isMainRod === 'boolean'
                            ? getImplantedProducts.isMainRod
                                ? 'Yes'
                                : 'No'
                            : null;
                }
            });
        });
    }

    unidProducts.push({
        description: '',
        productCFN: 'None',
        isChecked:
            (existingUnidItems && existingUnidItems.length === 0) ||
            !existingUnidItems ||
            unidProducts.every((item) => item.isChecked == false)
                ? true
                : false,
    });

    return unidProducts;
};

export const getItemsCheckedObj = (unidItems) => {
    const checkedItems =
        unidItems &&
        unidItems.length > 0 &&
        unidItems.filter(
            (item) => item.productCFN !== 'None' && item.isChecked
        );
    return {
        fewItemsChecked:
            checkedItems &&
            checkedItems.length > 0 &&
            checkedItems.length < unidItems.length - 1,
        allItemsChecked:
            checkedItems &&
            checkedItems.length > 0 &&
            checkedItems.length === unidItems.length - 1,
    };
};
